import mainComponent from '@/layouts/main/Main.vue'

export default [{
  path: '/',
  component: mainComponent,
  children: [{
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      requiresAuth: true
    }
  }],
}, ];